import { monthDay, t, time, weekday } from '../i18n/index.ts';

// age describes how long ago a time was, in the short form the map shows next
// to every location (constitution III: no location without its age).
export function age(iso: string | undefined, now: number = Date.now()): string {
  if (!iso) return t('componentsAgeNever');
  const secs = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (secs < 60) return t('ageJustNow');
  const mins = Math.round(secs / 60);
  if (mins < 60) return t('ageMinutes', { n: mins });
  const hours = Math.round(mins / 60);
  if (hours < 48) return t('ageHours', { n: hours });
  return t('ageDays', { n: Math.round(hours / 24) });
}

// clock formats a time of day in the viewer's locale.
export function clock(iso: string): string {
  return time(new Date(iso));
}

// when formats a past time with its day: the time alone today, the weekday
// within a week, and the date before that.
export function when(iso: string, now: number = Date.now()): string {
  const d = new Date(iso);
  const at = clock(iso);
  const today = new Date(now);
  if (d.toDateString() === today.toDateString()) return at;
  if (now - d.getTime() < 6 * 86_400_000) return t('componentsWhenWeekday', { weekday: weekday(d, true), time: at });
  return t('componentsWhenDate', { date: monthDay(d), time: at });
}
